import styled from "styled-components";

export const ContactPageWrapper = styled.div`
  padding-bottom: 25px;
`;
